import React, { useState, useRef, useEffect } from 'react';
import { Drawer } from 'antd';

import EditResult from 'modules/main/lab_result/edit_result';
import LabResult from 'modules/main/lab_result/search_result';
import PrintResult from 'modules/main/lab_result/print_result';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

const EditLabResult = () => {
	const [isDisplayDrawer, setIsDisplayDrawer] = useState(false);
	const [isDisplayPrintPreview, setIsDisplayPrintPreview] = useState(false);
	const [patientInfo, setPatientInfo] = useState({});
	const [examDetails, setExamDetails] = useState({});
	const [selectedSampleID, setSelectedSampleID] = useState(null);
	const [selectedRequestID, setSelectedRequestID] = useState(null);
	const [selectedResultStatus, setSelectedResultStatus] = useState(null);
	const [selectedSpecimenStatus, setSelectedSpecimenStatus] = useState(null);
	const [selectedSectionName, setSelectedSectionName] = useState(null);
	const [specimenStatusID, setSpecimenStatusID] = useState(null);

	const [count, setCount] = useState(0);

	const labResultRef = useRef();

	const onClosePrintPreview = () => {
		setSelectedSampleID(null);
		setSelectedRequestID(null);
		setIsDisplayPrintPreview(false);
		setSelectedSpecimenStatus(null);
		setSpecimenStatusID(null);
	};

	const onClosePatientInfoDrawer = () => {
		setIsDisplayDrawer(false);
		labResultRef.current.refreshTable();
	};

	const onClickTableRow = ({ patientInfo, examDetails }) => {
		setPatientInfo(patientInfo);
		setExamDetails(examDetails);
		setIsDisplayDrawer(true);

		setCount(count + 1);
	};

	const onClickPrint = async (
		sampleID,
		requestID,
		specimenStatus,
		sectionName,
		specimenStatusID,
	) => {
		setIsDisplayPrintPreview(true);
		setSelectedSampleID(sampleID);
		setSelectedRequestID(requestID);
		setSelectedSpecimenStatus(specimenStatus);
		setSelectedSectionName(sectionName);
		setSpecimenStatusID(specimenStatusID);
	};

	const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
	const objectToSend = { color: '#8A73F9', patientInfo, examDetails, loggedinUser };
	const base64Params = btoa(JSON.stringify(objectToSend)); // Base64 encoding
	const encodedParams = encodeURIComponent(base64Params); // URL encoding
	// const link = `${process.env.REACT_APP_MICROBIOLOGY}/results?parameter=${encodedParams}`;

	// const link = `http://localhost:3001/results?parameter=${encodedParams}`;

	const link = `https://mcb.dxvista.com/results?parameter=${encodedParams}`;

	console.log(link);

	return (
		<div>
			<LabResult
				ref={labResultRef}
				pageTitle="LABORATORY RESULT"
				onClickTableRow={onClickTableRow}
				onClickPrint={onClickPrint}
			/>
			{examDetails.SectionID === 6 ? (
				<Drawer
					title="PATIENT LAB RESULT - MICROBIOLOGY"
					onClose={onClosePatientInfoDrawer}
					width="96%"
					visible={isDisplayDrawer}
				>
					<iframe
						style={{
							width: '100%',
							height: '100%',
							border: 'none',
							overflow: 'hidden',
						}}
						src={link}
						title="description"
					></iframe>
				</Drawer>
			) : (
				<Drawer
					title="PATIENT LAB RESULT"
					onClose={onClosePatientInfoDrawer}
					width="95%"
					visible={isDisplayDrawer}
				>
					{isDisplayDrawer && <EditResult patientInfo={patientInfo} examDetails={examDetails} />}
				</Drawer>
			)}

			<PrintResult
				sampleID={selectedSampleID}
				requestID={selectedRequestID}
				onClose={onClosePrintPreview}
				visible={isDisplayPrintPreview}
				resultStatus={selectedResultStatus}
				specimenStatus={selectedSpecimenStatus}
				sectionName={selectedSectionName}
				specimenStatusID={specimenStatusID}
			/>
		</div>
	);
};

export default EditLabResult;
